exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question-hollow img {\n  display: block;\n}\n.question-hollow .fill_image_blank {\n  height: 24px;\n  line-height: 22px;\n  font-size: 16px;\n  color: #80d74a;\n  border: 1px solid #b6bfd1;\n  border-radius: 2px;\n  position: absolute;\n}\n.question-hollow .fill_image_blank[data-size='small_img_blank'] {\n  width: 20px;\n}\n.question-hollow .fill_image_blank[data-size='img_blank'] {\n  width: 40px;\n}\n.question-hollow .fill_image_blank[data-size='big_img_blank'] {\n  width: 80px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"importLoaders":1}!./src/entry_question_editor/question/exercise/hollow/index.less
// module id = 1097
// module chunks = 60 61 62